import styled from 'styled-components';

// CONSTANTS
import { WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const WelcomeContainer = styled.section`
  position: relative;
  padding-top: 65px;
  padding-bottom: 65px;
  min-height: 645px;

  ${breakpoints.down('sm')} {
    padding-top: 25px;
    padding-bottom: 0;
    min-height: auto;
  }

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 0;
    height: 100%;
    width: 50%;
  }

  &:before {
    left: 0;
    background-color: ${p => p.theme.palette.home.left};
  }

  &:after {
    right: 0;
    background-color: ${WHITE};
  }

  ${breakpoints.down('sm')} {
    background-color: ${p => p.theme.palette.home.left};
    text-align: center;

    :before,
    &:after {
      display: none;
    }
  }

  .welcome {
    &__left {
      padding-bottom: 0;
      color: ${p => p.theme.palette.home.leftText};

      ${breakpoints.down('sm')} {
        padding-bottom: 0;
      }

      ${breakpoints.down('xs')} {
        padding-bottom: 24px;
      }
    }

    &__right {
      ${breakpoints.up('md')} {
        padding-left: 26px;
      }

      ${breakpoints.down('sm')} {
        padding-top: 40px;
        padding-bottom: 30px;
      }
    }
  }

  .page-content {
    position: relative;
    z-index: 1;
    padding-bottom: 16px;

    .MuiGrid-item {
      position: relative;
    }

    ${breakpoints.down('sm')} {
      > .MuiGrid-container .MuiGrid-item:last-of-type {
        background-color: ${WHITE};
      }
    }
  }
`;

export default WelcomeContainer;
